var c = function c(t) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return t > o ? o : t < r ? r : t;
  },
  n = function n(t) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Math.pow(10, r);
    return Math.round(o * t) / o;
  };
export { c as clamp, n as round };